import '.dh{padding:12px 16px;}.ssr-plugin'
import '.cx{border-radius:24px;}.ssr-plugin'
import '.b1{box-sizing:border-box;}.ssr-plugin'
import '.di{outline:none;}.ssr-plugin'
import '.ce{font-size:16px;}.ssr-plugin'
import '.e{display:flex;}.ssr-plugin'
import '.dj{cursor:pointer;}.ssr-plugin'
import '.w{align-items:center;}.ssr-plugin'
import '.dk{min-height:44px;}.ssr-plugin'
import '.dl{gap:10px;}.ssr-plugin'
import '.dm{transition:all 200ms ease;}.ssr-plugin'
import '.a4{margin-left:auto;}.ssr-plugin'
import { styled, Style } from 'inlines'
import { colors } from '../utils/colors.js'
import { transparentColor } from '../utils/transparentcolor.js'

type ButtonProps = {
  onClick?: (e?: any) => void
  style?: Style
  children: React.ReactNode
  leadIcon?: React.ReactNode
  trailIcon?: React.ReactNode
  ariaLabel?: string
  disabled?: boolean
  variant?: 'fill' | 'border' | 'ghost'
  fullWidth?: boolean
  id?: string
}

export const Button = ({
  onClick,
  style,
  children,
  leadIcon,
  trailIcon,
  ariaLabel,
  disabled,
  variant = 'fill',
  fullWidth,
  id,
}: ButtonProps) => {
  return (
    <styled.button className="dh cx b1 di ce e dj w dk dl dm"
      onClick={onClick}
      disabled={disabled}
      aria-label={ariaLabel}
      id={id}
      style={
        {
          backgroundColor:
            variant === 'ghost'
              ? 'transparent'
              : variant === 'border'
                ? colors.border
                : colors.white,
          color:
            variant === 'border' || variant === 'ghost'
              ? colors.white
              : colors.secondary,
          border:
            variant === 'ghost'
              ? '1px solid transparent'
              : `1px solid ${colors.border}`,
          width: fullWidth ? '100%' : 'fit-content',
          backdropFilter: variant === 'border' ? 'blur(8px)' : 'none',
          WebkitBackdropFilter: variant === 'border' ? 'blur(8px)' : 'none',
          '&:hover': {
            backgroundColor: disabled
              ? ''
              : variant === 'border'
                ? transparentColor(colors.white, 0.2)
                : variant === 'fill'
                  ? transparentColor(colors.white, 0.8)
                  : transparentColor(colors.white, 0.2),
            border:
              variant === 'ghost' && !disabled
                ? `1px solid ${colors.border}`
                : undefined,
            opacity: disabled ? 0.25 : 1,
            scale: disabled ? 1 : 0.98,
          },
          '&:disabled': {
            opacity: 0.25,
            cursor: 'not-allowed',
          },
          "html[dir='rtl'] & svg": {
            transform: 'scaleX(-1)',
          },
          "html[dir='rtl'] & span": {
            marginLeft: '0',
            marginRight: 'auto',
          },
          ...style,
        } as Style
      }
    >
      {leadIcon}
      {children}
      {trailIcon && fullWidth ? (
        <span className="a4 e w"
        >
          {trailIcon}
        </span>
      ) : (
        trailIcon
      )}
    </styled.button>
  )
}
